import { Component, OnInit, OnDestroy } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { Subscription } from 'rxjs';
import { filter } from 'rxjs/operators';

interface TenantSession {
  tenant_id: string;
  account_key: string;
  store_name: string;
  tenant_name: string;
  username: string;
  logged_in_at: Date;
  expires_at: Date;
}

@Component({
  selector: 'app-tenant-layout',
  templateUrl: './tenant.component.html'
})
export class TenantComponent implements OnInit, OnDestroy {

  tenantSession: TenantSession | null = null;
  accountKey: string = '';
  currentYear: number = new Date().getFullYear();
  private routerSubscription: Subscription;

  constructor(private router: Router) {}

  ngOnInit() {
    this.loadTenantSession();

    // Reload session on every navigation to catch login/logout state changes
    this.routerSubscription = this.router.events
      .pipe(filter(event => event instanceof NavigationEnd))
      .subscribe(() => {
        this.loadTenantSession();
      });
  }

  ngOnDestroy() {
    if (this.routerSubscription) {
      this.routerSubscription.unsubscribe();
    }
  }

  loadTenantSession() {
    const sessionStr = localStorage.getItem('tenant_session');
    if (sessionStr) {
      this.tenantSession = JSON.parse(sessionStr);
      this.accountKey = this.tenantSession?.account_key || '';
    }
  }

  logout() {
    localStorage.removeItem('tenant_session');
    this.tenantSession = null;

    // Get account key from URL if available
    const urlParts = this.router.url.split('/');
    const accountKeyIndex = urlParts.indexOf('tenant') + 1;
    const accountKey = urlParts[accountKeyIndex] || '';

    this.router.navigate([`/tenant/${accountKey}/login`]);
  }

  isLoggedIn(): boolean {
    if (!this.tenantSession) return false;

    const expiresAt = new Date(this.tenantSession.expires_at);
    if (new Date() > expiresAt) {
      localStorage.removeItem('tenant_session');
      this.tenantSession = null;
      return false;
    }

    return true;
  }
}
